module.exports = __webpack_public_path__ + "img/VDeVuyst.ad97321f.png";